/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Box } from 'grommet';
import { useHistory } from 'react-router';
import { LoneIconButton } from '@blend/enterprise-components';

/**
 * A sidebar for pages at secondary navigation level.
 * Unlike sidebar {@link NotarySidebar} for top level page  with navigation links and profile menu,
 * this one has only back button to allow user to go back to top level page */

export const SecondarySidebar: React.FC<{}> = () => {
  const history = useHistory();
  return (
    <Box background={'night'} data-it="it-SecondLevelSideBar" flex={false} height="100vh" justify="between">
      <LoneIconButton
        btnSize="sm"
        icon="arrow_back"
        iconSize={24}
        id="it-backButton"
        onClick={history.goBack}
        theme="light"
      />
    </Box>
  );
};
